/**
 * cart-upsell-persist.js
 *
 * Dawn has TWO replace paths:
 *
 * A) CartDrawer.renderContents()  — empty → has items (product page ATC)
 *    Replaces: #CartDrawer innerHTML entirely
 *
 * B) CartDrawerItems re-render   — qty / remove while cart has items
 *    Replaces: .drawer__inner innerHTML
 *
 * Both wipe #CartUpsell. Fix: observe the stable outer #CartDrawer node
 * with subtree:false so any child replacement is caught, then always
 * re-query .drawer__inner fresh before injecting.
 */

(function () {
  'use strict';

  var UPSELL_ID      = 'CartUpsell';
  var CART_DRAWER_ID = 'CartDrawer';

  /* Saved upsell outer HTML — captured once on page load */
  var savedUpsellHTML = null;

  function getDrawerInner() {
    var cd = document.getElementById(CART_DRAWER_ID);
    return cd ? cd.querySelector('.drawer__inner') : null;
  }

  function captureUpsell() {
    var di = getDrawerInner();
    if (!di) return;
    var upsell = di.querySelector('#' + UPSELL_ID);
    if (upsell && !savedUpsellHTML) {
      savedUpsellHTML = upsell.outerHTML;
    }
  }

  /* ── Show / hide ── */
  function applyVisibility(cartItems) {
    var di = getDrawerInner();
    if (!di) return;
    var upsell = di.querySelector('#' + UPSELL_ID);
    if (!upsell) return;
    if (cartItems && cartItems.length > 0) {
      upsell.classList.remove('cart-upsell--hidden');
    } else {
      upsell.classList.add('cart-upsell--hidden');
    }
  }

  /* ── Re-inject if missing ── */
  function reInjectUpsell() {
    if (!savedUpsellHTML) return;
    var di = getDrawerInner();
    if (!di) return;
    if (di.querySelector('#' + UPSELL_ID)) return; /* already there */

    var tmp = document.createElement('div');
    tmp.innerHTML = savedUpsellHTML;
    var freshUpsell = tmp.firstElementChild;
    if (!freshUpsell) return;

    var footer = di.querySelector('.drawer__footer');
    if (footer) {
      di.insertBefore(freshUpsell, footer);
    } else {
      di.appendChild(freshUpsell);
    }

    attachAtcListener(di.querySelector('#' + UPSELL_ID));
  }

  /* ── Sync button states ── */
  function syncButtons(cartItems) {
    var di = getDrawerInner();
    if (!di) return;
    var upsell = di.querySelector('#' + UPSELL_ID);
    if (!upsell) return;

    var cartIds = (cartItems || []).map(function (i) { return i.product_id; });

    upsell.querySelectorAll('.cart-upsell__card').forEach(function (card) {
      var pid = parseInt(card.dataset.productId, 10);
      var btn = card.querySelector('.cart-upsell__atc');
      if (!btn) return;
      if (cartIds.indexOf(pid) !== -1) {
        btn.classList.remove('cart-upsell__atc--loading');
        btn.classList.add('cart-upsell__atc--added');
        btn.disabled = false;
        btn.innerHTML = checkSVG();
      } else {
        btn.classList.remove('cart-upsell__atc--added', 'cart-upsell__atc--loading');
        btn.disabled = false;
        btn.innerHTML = plusSVG();
      }
    });
  }

  /* ── Full refresh: inject → show/hide → sync ── */
  function fullRefresh() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        reInjectUpsell();
        applyVisibility(cart.items);
        syncButtons(cart.items);
      })
      .catch(function () {});
  }

  /* ── ATC click handler (delegated on .drawer__inner) ── */
  function attachAtcListener(upsellEl) {
    if (!upsellEl) return;
    /* Remove previous listener by cloning the node — avoids double-binding */
    upsellEl.addEventListener('click', function (e) {
      var btn = e.target.closest('.cart-upsell__atc');
      if (
        !btn ||
        btn.disabled ||
        btn.classList.contains('cart-upsell__atc--added') ||
        btn.classList.contains('cart-upsell__atc--loading')
      ) return;

      var variantId = parseInt(btn.dataset.variantId, 10);
      if (!variantId) return;

      btn.classList.add('cart-upsell__atc--loading');
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add failed');
          return res.json();
        })
        .then(function () {
          /* Let Dawn's normal cart refresh run (it will trigger the observer)
             but also do our own refresh to ensure upsell stays */
          return fetch('/?sections=cart-drawer,cart-icon-bubble')
            .then(function (r) { return r.json(); })
            .then(function (data) {
              var parse = function (html) {
                return new DOMParser().parseFromString(html, 'text/html');
              };

              if (data['cart-drawer']) {
                var doc = parse(data['cart-drawer']);
                var newInner = doc.querySelector('.drawer__inner');
                var di = getDrawerInner();
                if (newInner && di) {
                  mainObserver.disconnect();
                  di.innerHTML = newInner.innerHTML;
                  fullRefresh();
                  observeCartDrawer();
                }
              }

              if (data['cart-icon-bubble']) {
                var bubbleDoc = parse(data['cart-icon-bubble']);
                var nb = bubbleDoc.querySelector('#cart-icon-bubble');
                var ob = document.getElementById('cart-icon-bubble');
                if (nb && ob) ob.innerHTML = nb.innerHTML;
              }
            });
        })
        .catch(function () {
          btn.classList.remove('cart-upsell__atc--loading');
          btn.disabled = false;
        });
    });
  }

  /* ── Observe #CartDrawer (stable node that survives both replace paths) ── */
  var mainObserver = new MutationObserver(function () {
    /* Short delay so Dawn finishes writing innerHTML */
    setTimeout(fullRefresh, 50);
  });

  function observeCartDrawer() {
    var cd = document.getElementById(CART_DRAWER_ID);
    if (!cd) return;
    mainObserver.observe(cd, { childList: true, subtree: true });
  }

  /* ── Sync on drawer open ── */
  var cartDrawerEl = document.querySelector('cart-drawer');
  if (cartDrawerEl) {
    var lastActive = false;
    new MutationObserver(function () {
      var isActive = cartDrawerEl.classList.contains('active');
      if (isActive && !lastActive) fullRefresh();
      lastActive = isActive;
    }).observe(cartDrawerEl, { attributes: true, attributeFilter: ['class'] });
  }

  function checkSVG() {
    return '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true"><polyline points="2,7 5.5,10.5 12,3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  function plusSVG() {
    return '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true"><line x1="7" y1="1" x2="7" y2="13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><line x1="1" y1="7" x2="13" y2="7" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
  }

  /* ── Boot ── */
  function init() {
    captureUpsell();
    var di = getDrawerInner();
    if (di) attachAtcListener(di.querySelector('#' + UPSELL_ID));
    observeCartDrawer();
    fullRefresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
